import cn from 'classnames'
import { Button, utils } from '@grammarly/badger-ui'

import styles from './cta.module.scss'

import { buttonColorToClass, buttonStatusToBadgerStatus, ButtonCtaProps, ButtonColor } from '../types'
import { CtaArrow } from '../../icons/cta-arrow'
import { usePageTheme } from '../../../../contexts/page-theme-context'

const { forwardRef } = utils

export const ButtonCta = forwardRef<ButtonCtaProps, 'button'>(
  ({ className, compact, color, text, showArrow, status: cmsStatus, ...restProps }, ref) => {
    const status = buttonStatusToBadgerStatus(cmsStatus)
    const { color: pageThemeColor } = usePageTheme()

    return (
      <Button
        {...restProps}
        ref={ref}
        status={status}
        padding={compact ? 'compact' : 'cta'}
        className={cn(
          styles.container,
          color !== ButtonColor.WDK24GoogleSecondaryDarkBg &&
            buttonColorToClass(color, pageThemeColor === 'convertTo2024'),
          className
        )}
      >
        {text}
        {/* ctaArrow className is needed for Hero Section Wide styling */}
        {showArrow && (
          <span className={cn(compact ? styles.arrowCompact : styles.arrow, 'ctaArrow')} aria-hidden={true}>
            <CtaArrow />
          </span>
        )}
      </Button>
    )
  }
)
